import React from "react";

function L00JumpNavComponentCode() {
  return (
    <div>
      {/* L00jumpNav - section jump-link navigation */}
      <div className="lego l00jumpNav legoMargin4">
        <nav className="jumpNavContainer">
          <a className="jumpNavButton" href="#">General Nutrition</a>
          <a className="jumpNavButton" href="#">Gut Health</a>
          <a className="jumpNavButton" href="#">Kidney Health</a>
          <a className="jumpNavButton" href="#">Bone Health</a>
          <a className="jumpNavButton" href="#">Managing Diabetes</a>
          <a className="jumpNavButton" href="#">Helpful Websites &amp; Apps</a>
        </nav>
      </div>
      {/* End L00jumpNav */}
    </div>
  );
}

export default L00JumpNavComponentCode;
